import { INVESTORCALLTRANSCRIPTS } from "./type";
import { API_URL } from "../config";
import axios from "axios";

const investorcalltransFn = (data) =>{
    const dt = {...data, IsSuccess:1};
    return{
        type: INVESTORCALLTRANSCRIPTS,
        payload: dt
    };
}

export const investorcalltransApi = (cid, yid) =>{
    let data ={category_id:cid, year_id:yid};
    return (dispatch) =>{
        axios.post(API_URL + 'FinancialInformationTranscriptNew', data).then((response) =>{
            if (response.data && response.data.fin_docs) {
                try {
                    let docs = JSON.parse(response.data.fin_docs);
                    if (Array.isArray(docs)) {
                        docs.sort((a, b) => {
                            if (b.id !== a.id) return (b.id || 0) - (a.id || 0);
                            return new Date(b.created_at) - new Date(a.created_at);
                        });
                        response.data.fin_docs = JSON.stringify(docs);
                    }
                } catch (e) {}
            }
            dispatch(investorcalltransFn(response));
        });
    };
}